import request from '../utils/request'

// 6，3月份的数据
/**
 * 招商引资
 */
export const ApiGetZSYZ_6 = params => {
  return request.get('/magic-api/jsc/recruit/query', { params })
}
/**
 * 稳商扩资
 */
export const ApiGetWSKZ_6 = params => {
  return request.get('/magic-api/jsc/steady/query', { params })
}

/**
 * 拔钉清零
 */
export const ApiGetBDQL = params => {
  return request.get('/magic-api/jsc/bdql/query', { params })
}
/**
 * 总体进展
 */
export const ApiGetZTJZ = params => {
  return request.get('/magic-api/jsc/zhuanxxd/query', { params })
}
/**
 * 老创改开->新6+2
 */
export const ApiGetCGK = params => {
  return request.get('/magic-api/jsc/cgk/query', { params })
}
/**
 * 专报简报
 */
export const ApiGetZBJB = params => {
  return request.get('/magic-api/jsc/zbjb/getPeriod', { params })
}
/**
 * 招商引资新接口
 */
export const ApiGetZSYZ = params => {
  return request.get('/magic-api/jsc/zsyz/getByMonthToTable', { params })
}
/**
 * 稳商扩资新接口
 */
export const ApiGetWSKZ = params => {
  return request.get('/magic-api/jsc/wskz/getByMonth', { params })
}



// WEBPACK FOOTER //
// ./src/api/zsyz.js